import { Link } from 'react-router-dom';
import { kq } from '../../config/routes';
import { DOWNLOADS_PATH } from '../../config/downloads';
import { TERMINALX_PATH } from '../../config/terminalx';
import './Footer.css';

/** Copy unchanged from the current site. */
export default function Footer() {
  return (
    <footer className="rw-footer">
      <div className="rw-footer__inner">
        <div>
          <div className="rw-footer__brand">RIFTWORKS</div>
          <div className="rw-footer__tag">Endless Possibilities</div>
        </div>
        <div className="rw-footer__col">
          <div className="rw-footer__label">Applications</div>
          <a href="#kuestion">Kuestion</a>
          <Link to={TERMINALX_PATH}>TerminalX</Link>
          <Link to={DOWNLOADS_PATH}>Downloads</Link>
          <a href={kq('kb')} target="_blank" rel="noopener noreferrer">Knowledge base</a>
        </div>
        <div className="rw-footer__col">
          <div className="rw-footer__label">Company</div>
          <a href="#about">About us</a>
          <a href="#contact">Contact</a>
        </div>
      </div>
    </footer>
  );
}
